import type { ReactNode } from "react";

/**
 * Состояние плеера для оверлеев: видимость контролов (PromoButtonWidget),
 * текущее время (опросы на записи всплывают на своей минуте) и каст
 * (реакции и опросы прячутся, пока видео идёт на телевизоре).
 */
export interface PlayerOverlayState {
  controlsVisible: boolean;
  currentTime: number;
  isCasting: boolean;
}

export type PlayerOverlay =
  | ReactNode
  | ((state: PlayerOverlayState) => ReactNode);

/**
 * Экраны ошибки и оплаты в ContentPlayer не монтируют Player: оверлей
 * видит контролы видимыми, как раньше при вызове overlay(true).
 */
export const STATIC_PLAYER_OVERLAY_STATE: PlayerOverlayState = {
  controlsVisible: true,
  currentTime: 0,
  isCasting: false,
};

export function renderPlayerOverlay(
  overlay: PlayerOverlay | undefined,
  state: PlayerOverlayState,
): ReactNode {
  return typeof overlay === "function" ? overlay(state) : overlay;
}
